<template>
      <div class="type">
          <div class="type-top">
            <div class="type-top-left"></div>
            医疗器械经营许可证
          </div>
          <div class="type-text" v-if="permission != null">
            <div class="CodeText">
              许可证编号： <span>{{ permission.BusLicenceCode }}</span>
            </div>
            <div class="CodeText">
              企业名称： <span>{{ permission.BusCompanyName }}</span>
            </div>
            <div class="CodeText">
              经营方式： <span>{{ permission.BusBusinessMode }}</span>
            </div>
            <div class="CodeText">
              住所： <span>{{ permission.BusAddress }}</span>
            </div>
            <div class="CodeText">
              经营场所： <span>{{ permission.BusBusinessAddr }}</span>
            </div>
            <div class="CodeText">
              库房地址： <span>{{ permission.BusWarehouseAddr }}</span>
            </div>
            <div class="CodeText">
              注册地址： <span>{{ permission.BusRegisterAddr }}</span>
            </div>
            <div class="CodeText">
              法定代表人： <span>{{ permission.BusLegalRepresentative }}</span>
            </div>
            <div class="CodeText">
              企业负责人： <span>{{ permission.BusCEO }}</span>
            </div>
            <div class="CodeText">
              经营范围： <span>{{ permission.BusThirdInvSort }}</span>
            </div>
            <div class="CodeText">
              发证日期： <span>{{ permission.BusIssueDate }}</span>
            </div>
            <div class="CodeText">
              起始日期： <span>{{ permission.BusStartDate }}</span>
            </div>
            <div class="CodeText">
              失效日期： <span>{{ permission.BusEndDate }}</span>
            </div>
            <div class="CodeText">
              提交时间： <span>{{ permission.CreateTime }}</span>
            </div>
            <div class="CodeText">
              审核时间： <span>{{ permission.VerifyTime }}</span>
            </div>
            <div class="CodeText">
              驳回时间： <span>{{ permission.RejectTime }}</span>
            </div>
            <div class="CodeText">
              医疗器械经营许可证：
              <div class="imgBox">
                <!-- ${ config.http_URL } + -->
                <img :src="`${permission.BusPhotoURL}`">
              </div>
              <div class="imgTop2" style=" " slot="pos"><img src="@/assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(permission.BusPhotoURL)"></div>
            </div>

            <div class="CodeText">
              驳回原因： <span>{{ permission.RejectReason }}</span>
            </div>
          </div>
        </div>
</template>

<script>
  export default {
    components:{},
    props:{
        permission: {
            type: Object
        }
    },
    data(){
      return {
          
      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        imgShowClick(par){
            this.$emit('imgShowClick' , par)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');

  
</style>